import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import axios from 'axios';
import BrandingProvider from '@/components/layout/BrandingProvider';
import { useBrandingStore } from '@/store/branding.store';
import App from './App';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime:           1000 * 60 * 5,   // 5 min
      retry:               (failureCount, error) => {
        // Never retry 4xx client errors (except 429 which axios interceptor handles)
        if (axios.isAxiosError(error) && error.response) {
          const status = error.response.status;
          if (status === 429) return false;           // axios interceptor already retried
          if (status >= 400 && status < 500) return false; // don't retry client errors
        }
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
  },
});

// Hydrate branding from the server before first render.
// Suppresses the flash of default colours/name when localStorage was cleared.
// initBranding() is safe: it swallows network errors and falls back to
// whatever is already in the store (localStorage or hard-coded defaults).
(async () => {
  await useBrandingStore.getState().initBranding();

  ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrandingProvider>
        <App />
      </BrandingProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>,
  );
})();

